import React, { useState as uState, useEffect as uEffect } from 'react'

import Navbar from '../../components/navbar/Navbar'
import Sidebar from '../../components/sidebar/Sidebar'

export default function notifications() {

  const [newUser, setNewUser] = uState([])
  const [newProduct, setNewProduct] = uState([])
  const [newOrder, setNewOrder] = uState([])
  const [newDel, setNewDel] = uState([])


  const userNotifications = async () =>
  {
    await fetch('http://localhost:8000/users/userNotify', {
    method: 'POST',
    headers: {
      'Content-Type':'application/json'
      },
    body:JSON.stringify({})
  }).then((response) => response.json()).then((data) => setNewUser(data))}
  
  const productNotifications = async() => {
    await fetch('http://localhost:8000/products/productNotify', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({})
    }).then((response) => response.json()).then((data) => setNewProduct(data))
  }
  const orderNotifications = async () => {
    await fetch('http://localhost:8000/order/orderNotify', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({})
    }).then((response) => response.json()).then((data) => setNewOrder(data))
  }
  const deliveryNotifications = async () => {
    await fetch('http://localhost:8000/order/deliverNotify', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({})
    }).then((response) => response.json()).then((data) => setNewDel(data))
  }
  uEffect(() => {
    userNotifications()
    productNotifications()
    orderNotifications()
    deliveryNotifications()
  }, [])
  const filteredProducts = newOrder.filter(product => product.hasOwnProperty('ProductTitle'));
  const filteredDelivery = newDel.filter(product => product.hasOwnProperty('ProductTitle'));
  return (
    <>
      <div className="home">
        <Sidebar />
        <div className="homeContainer">
          <Navbar />
          <div className="listContainer">
            <div className='text-center'><h3>Orders</h3>
              {
                filteredProducts && filteredProducts.map((item, index) => (
                  <div key={index}>
                    <table className="table">
                      <thead>
                        <tr>
                          <th scope="col">#</th>
                          <th scope="col">Email</th>
                          <th scope="col">Title</th>
                          <th scope="col">Type</th>
                          <th scope="col">Amount</th>
                          <th scope="col">Quantity</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr className="alert alert-warning alert-dismissible fade show" role="alert">
                          <th scope="row">{index + 1}.</th>
                          <td>{item.UserEmail}</td>
                          <td>{item.ProductTitle}</td>
                          <td>{item.ProductType}</td>
                          <td>₹{item.ProductAmount}</td>
                          <td>{item.ProductQuantity}mg</td>
                          <td type="button" className="btn-close" data-bs-dismiss="alert" aria-label="Close"></td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                ))
              }
            </div>
          </div>
          <div className="listContainer">
            <div className='text-center'><h3>Users</h3>
              {
                newUser && newUser.map((item, index) => (
                  <div key={index}>
                    <table className="table">
                      <thead>
                        <tr>
                          <th scope="col">#</th>
                          <th scope="col">Name</th>
                          <th scope="col">Email</th>
                          <th scope="col">Mobile</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr className="alert alert-warning alert-dismissible fade show" role="alert">
                          <th scope="row">{index + 1}.</th>
                          <td>{item.UserName}</td>
                          <td>{item.UserEmail}</td>
                          <td>{item.UserMobile}</td>
                          <td type="button" className="btn-close" data-bs-dismiss="alert" aria-label="Close"></td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                ))
              }
            </div>
          </div>
          <div className="listContainer">
            <div className='text-center '><h3>Products</h3>
              {
                newProduct && newProduct.map((item, index) => (
                  <div key={index}>
                    <table className="table">
                      <thead>
                        <tr>
                          <th scope="col">#</th>
                          <th scope="col">Title</th>
                          <th scope="col">Type</th>
                          <th scope="col">Amount</th>
                          <th scope="col">Quantity</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr className="alert alert-warning alert-dismissible fade show" role="alert">
                          <th scope="row">{index + 1}.</th>
                          <td>{item.ProductTitle}</td>
                          <td>{item.ProductType}</td>
                          <td>₹{item.ProductAmount}</td>
                          <td>{item.ProductQuantity}mg</td>
                          <td type="button" className="btn-close" data-bs-dismiss="alert" aria-label="Close"></td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                ))
              }
            </div>
          </div>
          <div className="listContainer">
            <div className='text-center'><h3>Delivery</h3>
              {
                filteredDelivery && filteredDelivery.map((item, index) => (
                  <div key={index}>
                    <table className="table">
                      <thead>
                        <tr>
                          <th scope="col">#</th>
                          <th scope="col">Title</th>
                          <th scope="col">Type</th>
                          <th scope="col">Amount</th>
                          <th scope="col">Quantity</th>
                          <th scope="col">Status</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr className="alert alert-warning alert-dismissible fade show" role="alert">
                          <th scope="row">{index + 1}.</th>
                          <td>{item.ProductTitle}</td>
                          <td>{item.ProductType}</td>
                          <td>₹{item.ProductAmount}</td>
                          <td>{item.ProductQuantity}mg</td>
                          <td>{item.DeliveryStatus}</td>
                          <td type="button" className="btn-close" data-bs-dismiss="alert" aria-label="Close"></td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                ))
              }
            </div>

            </div>
        </div>
      </div>
          

          

          

      
      
      </>
  )
}
